module.exports = __webpack_public_path__ + "media/images/illustration_15-84560f9e678d2620a3754ff0a7e59658.png";